import React, { useState } from "react";

const Navbar = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 w-full bg-[#1a1209]/97 backdrop-blur-lg border-b border-[#2a2015]/80 px-3 sm:px-4 md:px-12 py-3 md:py-4"
      style={{ boxShadow: '0 4px 30px rgba(0,0,0,0.4)' }}
    >
      <nav className="max-w-7xl mx-auto flex items-center">
        <a href="#home" className="flex flex-col items-center justify-center leading-none shrink-0 gap-0 md:gap-0.5">
          <span className="text-[9px] sm:text-[11px] md:text-[14px] tracking-[0.38em] uppercase text-[#d5c6a7] translate-x-1 -mb-3 sm:-mb-4 md:-mb-5">A</span>
          <img
            src="/images/Kamya%20logo.png"
            alt="Kamya"
            className="h-16 sm:h-20 md:h-28 w-auto object-contain"
          />
          <span className="text-[10px] sm:text-[12px] md:text-[16px] tracking-[0.35em] md:tracking-[0.42em] uppercase text-[#d5c6a7] translate-x-1.5 -mt-4 sm:-mt-5 md:-mt-6">VENTURE</span>
        </a>

        {/* Desktop Navigation - pushed to the right */}
        <div className="hidden md:flex items-center gap-10 font-bold uppercase text-sm tracking-widest text-[#c4b89a] ml-auto">
          <a className="hover:text-primary transition-colors cursor-pointer" href="#home">
            Home
          </a>
          <a className="hover:text-primary transition-colors cursor-pointer" href="#products">
            Snacks
          </a>
          <a className="hover:text-primary transition-colors cursor-pointer" href="#about">
            About
          </a>
          <a className="hover:text-primary transition-colors cursor-pointer" href="#contact">
            Contact
          </a>
        </div>

        {/* Mobile Menu Button */}
        <div className="md:hidden flex items-center ml-auto -mr-1">
          <button
            className="p-2 hover:bg-primary/20 rounded-full transition-colors text-[#c4b89a]"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            <span className="material-symbols-outlined">
              {mobileMenuOpen ? "close" : "menu"}
            </span>
          </button>
        </div>
      </nav>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="md:hidden mt-4 pb-4 flex flex-col gap-4 font-bold uppercase text-sm tracking-widest text-[#c4b89a] border-t border-[#2a2015] pt-4">
          <a className="hover:text-primary transition-colors cursor-pointer" href="#home" onClick={() => setMobileMenuOpen(false)}>
            Home
          </a>
          <a className="hover:text-primary transition-colors cursor-pointer" href="#products" onClick={() => setMobileMenuOpen(false)}>
            Snacks
          </a>
          <a className="hover:text-primary transition-colors cursor-pointer" href="#about" onClick={() => setMobileMenuOpen(false)}>
            About
          </a>
          <a className="hover:text-primary transition-colors cursor-pointer" href="#contact" onClick={() => setMobileMenuOpen(false)}>
            Contact
          </a>
        </div>
      )}
    </header>
  );
};

export default Navbar;
